import type { CreateListingActionRequest } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { listingActionsApi } from '~/entities/listing-action/api/listing-actions-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

/** A place's Favoriten count and actions, refreshed while open so a push's reach shows up. */
export function useListingActions(businessId: string, listingId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.LISTING_ACTIONS, listingId),
    queryFn: () => listingActionsApi.list(businessId, listingId),
    staleTime: MINUTES / 2,
    refetchInterval: MINUTES / 2,
    enabled: !!businessId && !!listingId,
  })
}

export function useCreateListingAction(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ listingId, input }: { listingId: string; input: CreateListingActionRequest }) =>
      listingActionsApi.create(businessId, listingId, input),
    onSuccess: (_action, { listingId }) =>
      queryClient.invalidateQueries({ queryKey: queryKey(QueryKey.LISTING_ACTIONS, listingId) }),
  })
}

export function useEndListingAction(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ listingId, actionId }: { listingId: string; actionId: string }) =>
      listingActionsApi.end(businessId, listingId, actionId),
    onSuccess: (_action, { listingId }) =>
      queryClient.invalidateQueries({ queryKey: queryKey(QueryKey.LISTING_ACTIONS, listingId) }),
  })
}
